<h2 mat-dialog-title class="text-warn font-semibold">Motivo de bloqueo</h2>

<mat-dialog-content class="py-2">
    <p class="text-sm text-secondary mb-4">
        Indica el motivo por el que se bloquea el pago a este proveedor.
        Esta información será registrada junto con el cambio.
    </p>
    <mat-form-field class="w-full">
        <mat-label>Motivo</mat-label>
        <textarea
            matInput
            [(ngModel)]="reason"
            rows="3"
            maxlength="500"
            placeholder="Escribe el motivo del bloqueo...">
        </textarea>
        <mat-hint align="end">{{ reason.length }} / 500</mat-hint>
    </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()">Cancelar</button>
    <button
        mat-flat-button
        color="warn"
        [disabled]="!reason.trim()"
        (click)="onConfirm()">
        Confirmar bloqueo
    </button>
</mat-dialog-actions>
